import styled from 'styled-components';

import { ALIGN_TEXT } from 'adapter/in/common/widget/options';

type StyledHeaderProps = {
    alignText: ALIGN_TEXT;
};

type StyledBodyProps = {
    heightValue: number;
    hasHeader: boolean;
    alignText: ALIGN_TEXT;
};

export const StyledWidgetTextWrapper = styled.div`
    padding-bottom: 18px;
`;

export const StyledHeaderText = styled.div<StyledHeaderProps>`
    margin: 4px 12px 0px;
    text-align: ${({ alignText }) => `${alignText}`};
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const StyledBody = styled.div<StyledBodyProps>`
    margin: 10px 16px;
    font-size: 15px;
    font-weight: 400;
    line-height: normal;
    font-style: normal;
    display: -webkit-box;
    -webkit-line-clamp: ${({ heightValue, hasHeader }) =>
        heightValue !== 0 ? Math.floor((heightValue - 20 - (hasHeader ? 36 : 0)) / 18) : 'unset'};
    -webkit-box-orient: vertical;
    text-align: ${({ alignText }) => `${alignText}`};
    overflow: ${({ heightValue }) => (heightValue === 0 ? 'auto' : 'hidden')};
    white-space: pre-wrap;
`;
